import { useTranslation } from "react-i18next";

import _ from "lodash";
import Schemas from "schemas";

import PopUpWrapper from "./modal-wrapper";

import { Control } from "components/ui-kit/control";
import { Button, Form, Frame, Row } from "components/ui-kit/styled-templates";

import ClubsApi from "api/clubs-api";

import Select from "react-select";

import useFormControl from "hooks/useFormControl";
import useModal from "hooks/useModal";

import { EForms, EModals } from "types/enums";
import VisibilitySwitcher from "../auxiliary/tools/VisibilitySwitcher";
import { getFriendlyRegionsOptions } from "../rmap/RussiaMap";
import { CLUBS_TOURISM_OPTIONS } from "../../constants/config";

const EditClubModal = () => {
    const { t, i18n } = useTranslation();
    let isRu = i18n.language == "ru";

    const {
        data: formData,
        onSubmit,
        clearForm,
        setValues
    } = useFormControl({
        name: EForms.editClub,
        schema: Schemas[EForms.editClub]
    });
    const { close, state: modalState = {} } = useModal(EModals.CreateClub, {
        onOpen: ({ data = {} }: any) => setValues(data?.details ?? {})
    });
    const { mode, data } = modalState;

    const anyChanges = !_.isEqual(data?.details, formData);

    const handlers = {
        submit: async (details: any) => {
            if (mode === `create`) {
                await ClubsApi.createClub(details);
            } else {
                await ClubsApi.updateClub({ ...data, details });
            }
            close();
        }
    };
    return (
        <PopUpWrapper name={EModals.CreateClub} onClose={clearForm}>
            <Form name={EForms.editClub} onSubmit={onSubmit(handlers.submit)} extra={`h3 { margin-top: 0; };`}>
                <h3>{mode === `edit` ? `Редактирование студтурклуба` : `Добавить студтурклуб`}</h3>

                <Control.Row>
                    <Control.Input name="name" label={"Название"} placeholder="" isRequired />
                </Control.Row>


                <Control.Row>
                    {/*<Control.Select*/}
                    {/*    name="region"*/}
                    {/*    placeholder={"Субъект"}*/}
                    {/*    label={"Субъект"}*/}
                    {/*    options={getFriendlyRegionsOptions().map((i) => ({ value: i.label, label: i.label }))}*/}
                    {/*/>*/}
                    {/*<Control.Input name={`region`} placeholder={"Субъект"} label={"Субъект"} />*/}
                    <Control.Select
                        name="region"
                        placeholder={"Субъект"}
                        label={"Субъект"}
                        options={getFriendlyRegionsOptions().map((i) => ({ value: i.label, label: i.label }))}
                    />

                    <Control.Input name={`city`} placeholder={t("q5il3syjpje")} label={t("3tkatmlvp8x")} isRequired />
                </Control.Row>

                <Control.Row>
                    <Control.Input name={`street`} placeholder={t("8n9f3rr2sbt")} label={t("pr9sxmeigbg")} />
                    <Control.Input name={`houseNumber`} placeholder={t("infvocd2wc")} label={t("e94pq4sjlj")} />
                </Control.Row>


                <Control.Label>{t("pu9i9e02pk")}</Control.Label>

                <Control.Row extra={`align-items: flex-start;`}>
                    <Control.Map name={`coordinates`} extra={`width: 100%; flex: 1;`} />
                    <Frame extra={`width: 100%; flex: 1;`}>
                        <Control.Input name={`coordinates.lat`} placeholder={t("1jin4cxgvlh")} label={t("h0r2moy047")}
                                       regex="[^0-9.]" isRequired />
                        <Control.Input name={`coordinates.lng`} placeholder={t("ll0rks5gvc")} label={t("muvpa39wf2")}
                                       regex="[^0-9.]" isRequired />
                    </Frame>
                </Control.Row>

                <Control.Row>
                    <Control.Input name={`websiteUrl`} placeholder={isRu ? 'Ссылка на сайт' : 'Website URL'} label={isRu ? 'Ссылка на сайт' : 'Website URL'} />
                    <Control.Input name={`socialUrl`} placeholder={isRu ? 'Ссылка на соцсети' : 'Social networks URL'} label={isRu ? 'Ссылка на соцсети' : 'Social networks URL'} />
                </Control.Row>

                <Control.Textarea name="description" placeholder={t("x8a37e4roa9")}
                                  label={"Описание деятельности студтурклуба"}
                                  isRequired />

                <Control.Textarea name="history" placeholder={t("tmpwugwxya")} label={"История студтурклуба"} />


                <div style={{ marginBottom: "20px" }}>
                    <div style={{ fontSize: "13px" }}>
                        {"Виды туризма"}
                    </div>
                    <Control.Row extra={`margin-bottom: 10px;`}>
                        <Select
                            options={CLUBS_TOURISM_OPTIONS}
                            isMulti
                            isSearchable
                            isClearable={false}
                            placeholder={"Виды туризма"}
                            value={CLUBS_TOURISM_OPTIONS.filter(i => (formData?.tourismTypes || [])?.includes(i.value))}
                            onChange={(selectedOptions) => {
                                const newTourismTypes = selectedOptions?.map?.(i => i.value) ?? [];
                                setValues({ ...formData, tourismTypes: newTourismTypes });
                            }}
                        />
                    </Control.Row>
                </div>


                <Control.Textarea name="instructorsDescription" placeholder={t("tmpwugwxya")}
                                  label={"Информация об инструкторах"} />

                <Control.Textarea name="inventory" placeholder={t("tmpwugwxya")} label={"Инвентарь"} />

                <Control.Textarea name="rules" label={t("dua47ui53s")} placeholder="" isRequired />

                <Control.Input name="admin.name" label={t("5082d1df1fe")} placeholder="" isRequired />
                <Control.Row>
                    <Control.Input name="admin.phone" label={t("6dghy9qfm8")} placeholder={t("jrvbgn7q73l")}
                                   isRequired />
                    <Control.Input name="admin.email" label="Email" placeholder="email" isRequired />
                </Control.Row>

                {/**/}

                <Control.File name="photos" label={t("xqau8m9qa0r")}
                              dropzoneProps={{ label: `Загрузить фото (не более 2Мб, формат JPG, PNG)`}}
                              multiple isRequired />

                <Control.File
                    name="video"
                    label={t("kto47gay8f")}
                    accept="video/mp4, video/quicktime"
                    maxFilesNumber={1}
                    multiple
                    dropzoneProps={{ label: `Загрузить видео (не более 100Мб, формат MP4)`, icon: `dropzone-video` }}
                />

                {anyChanges && <Control.Error extra={`margin-bottom: 15px;`}>{t("2wi4n57eu8i")}</Control.Error>}

                {/*<Control.Checkbox name="hideMyInfo" placeholder={''} label={'Скрыть информацию для всех пользователей, кроме Администратора Платформы'} />*/}

                {/*{data?.id == undefined ? null :*/}
                {/*    <>*/}
                {/*        /!*@ts-ignore*!/*/}
                {/*        <VisibilitySwitcher*/}
                {/*            dbClassName={"Club"}*/}
                {/*            id={data?.id}*/}
                {/*            field={"hideFromAll"}*/}
                {/*        />*/}
                {/*    </>*/}
                {/*}*/}

                <Row extra={`width: inherit; justify-content: flex-end; gap: 10px;`}>
                    <Button variant="outlined" background="gray" onClick={close}>
                        {t("6niv212r1oq")}
                    </Button>
                    <Button type="submit" background="green">
                        {t("nxggj3etsx")}
                    </Button>
                </Row>
            </Form>
        </PopUpWrapper>
    );
};

export default EditClubModal;
